import { HttpErrorResponse } from '@angular/common/http';

export class EvidenceDetailsActionResult {
  constructor(public actionType: ActionType, public httpErrorResponse: HttpErrorResponse | null, public isSuccess: boolean) {}
}

export enum ActionType {
  UpdateEvidenceDetails = 'UpdateEvidenceDetails',
  UpdateEvidenceLocation = 'UpdateEvidenceLocation',
}
